import React from "react";
import styles from "./Footer.module.css";

export const Footer = () => {
  return (
    <>
      <footer className={styles.footer}>
        © 2022 - TODOS LOS DERECHOS RESERVADOS. COOPERATIVA DE SERVICIOS
        PUBLICOS DE COLONIA CAROYA Y JESUS MARIA LTDA.
      </footer>
    </>
  );
};

export default Footer;
